import { getTableSelectedIds } from '@dealstack/frontend/shared/components/Table/MantineTable/table-utils';
import { getTableMeta } from '@dealstack/frontend/shared/components/Table/MantineTable/types';
import { GetKYCWorkflowRowRes } from '@dealstack/shared/lib/generated/models/GetKYCWorkflowRowRes';
import { Table } from '@tanstack/react-table';
import {
	BulkAction,
	BulkActionGroup,
} from '@dealstack/frontend/shared/components/Table/MantineTable/ActionsButton/ActionsButton.types';

export interface KycDownloadSelection {
	allSelected: boolean;
	selectedIds: string[];
	excludedIds: string[];
}

export const createBulkActions = (
	table: Table<GetKYCWorkflowRowRes>,
	{
		isDownloading,
		onDownload,
		downloadLabel,
	}: {
		isDownloading: boolean;
		onDownload: (selection: KycDownloadSelection) => void;
		downloadLabel: string;
	}
): BulkActionGroup<GetKYCWorkflowRowRes> => {
	const secondary: BulkAction<GetKYCWorkflowRowRes>[] = [
		{
			key: 'download_kyc',
			label: downloadLabel,
			disabled: isDownloading,
			onExecute: () => {
				const { greedySelecting } = getTableMeta(table);
				const ids = getTableSelectedIds(table);
				onDownload({
					allSelected: greedySelecting,
					selectedIds: greedySelecting ? [] : ids,
					excludedIds: greedySelecting ? ids : [],
				});
			},
		},
	];

	return { secondary };
};
